<template>
  <main class="login login-screen">
    <v-container fill-height class="login-container">
      <img
        :src="require('../../assets/_2/ic_logo_jns_menu.png')"
        class="login-logo"
        alt
      />
      <v-layout row wrap>
        <v-flex xs12 v-if="!mostraMensagemBloqueio">
          <form-alert 
            id="alerta_erro_login"
            :type="alertText.type"
            :message="alertText.message"
            @close="closeFormAlert"
          ></form-alert>
        </v-flex>
        <v-flex class="text-xs-center no-padding" offset-xs2 xs8>
          <div class="main-title">
            <p class="yellow--text mb-0 line-1">Seja bem-vindo ao</p>
            <p class="white--text font-weight-black text-uppercase line-2">
              Portal do Corretor
            </p>
          </div>
          <v-form class="login-form" @click.prevent>
            <div class="login-error" v-if="formErrors && formErrors.error">
              <div class="input-group__error">
                <v-icon>warning</v-icon>
                {{ formErrors.error }}
              </div>
            </div>
            <v-flex xs12>
              <v-text-field
                v-model="model.username"
                :label="'E-mail'"
                placeholder=" "
                hide-details
                height="45"
                class="login-input mb-4 input-email"
                id="login_input_email"
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-text-field
                v-model="model.password"
                label="Senha"
                placeholder=" "
                height="45"
                type="password"
                class="login-input"
                hide-details
                id="login_input_password"
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <button
                @click.prevent="getCompanies(model)"
                class="
                  btn-primary
                  jns-button
                  mt-4
                  jns-button-login
                  font-weight-black
                "
                id="login_button_login"
              >
                Entrar
              </button>
            </v-flex>

            <v-flex xs12>
              <a
                class="recover-password-link mt-5"
                @click.prevent="recoverPasswordDialog = true"
                id="login_button_recoverpassword"
                >Recuperar Senha</a
              >
              <br />

              <hr class />
              <router-link
                :to="{ path: '/cadastrar' }"
                tag="button"
                class="
                  btn-primary
                  jns-button
                  yellow-button
                  mt-5
                  register-button
                "
                id="login_button_register"
                v-html="'Seja nosso parceiro, cadastre-se aqui'"
              ></router-link>
            </v-flex>
          </v-form>
        </v-flex>
      </v-layout>
      <v-dialog v-model="selectCompanyDialog" :max-width="'640'">
        <selecionar-empresa-modal
          @close="
            selectCompanyDialog = false;
            $forceUpdate();
          "
          @click="selectCompanyToLogin"
          persistent
          :companies="companies"
        ></selecionar-empresa-modal>
      </v-dialog>

      <v-dialog v-model="recoverPasswordDialog" persistent :max-width="'640'">
        <recuperar-senha-modal
          @close="
            recoverPasswordDialog = false;
            $forceUpdate();
          "
          :companies="companies"
        ></recuperar-senha-modal>
      </v-dialog>

      <v-dialog v-model="createPasswordDialog" persistent :max-width="'640'">
        <criar-senha-modal
          :hash="createPasswordHash"
          :username="$route.params.email"
          @close="
            (username, password) => {
              createPasswordDialog = false;
              (model = username), password;
              getCompanies(username, password);
            }
          "
        ></criar-senha-modal>
      </v-dialog>

      <v-dialog v-model="blockUserDialog" persistent :max-width="'640'">
        <bloquear-usuario-modal
          :hash="blockUserHash"
          :users="companyUsers"
          :username="$route.params.email"
          @close="blockUserDialog = false"
        ></bloquear-usuario-modal>
      </v-dialog>
      <versao-label />
    </v-container>
  </main>
</template>

<script lang="js">
import axios from "axios";
import ViewMixin from "@/mixins/ViewMixin";
import { mapActions } from "vuex";

export default {
  name: "Home",
  mixins: [ViewMixin],
  data: () => ({
    formErrors: [],
    model: {
      username: null,
      password: null,
      me: undefined,
    },
    selectCompanyDialog: false,
    recoverPasswordDialog: false,
    createPasswordDialog: false,
    blockUserDialog: false,
    createPasswordHash: false,
    blockUserHash: false,
    companies: false,
    companyUsers: false,
    debugMode: false,
    imgNovidade: "require('../../assets/novas_demandas.png')",
  }),
  methods: {
    ...mapActions(["GET_NOVIDADES"]),
    personalInfo(data) {
      this.$store
        .dispatch("ME_INFO", data)
        .then((response) => {
          // this.$store.main.commit('ME',payload).then(response => {
          localStorage.setItem("me", JSON.stringify(response));
          this.$router.push({ name: "Consultorias" });
        })
        .catch(this.errorHandler);
    },
    auth(data) {
      this.showLoadingIndicator();
      this.$store
        .dispatch("LOGIN", data)
        .then(this.authHandler)
        .catch(this.selectCompanyErrorHandler);
    },
    async getCompanies(data) {
      if (!this.model.username || !this.model.password) return;

      this.model.username = this.model.username.toLowerCase();
      this.showLoadingIndicator();
      await this.$store
        .dispatch("GET_COMPANIES", data)
        .then(this.companiesHandler)
        .catch(this.companiesHandlerError);
    },

    companiesHandler(response) {
      if (response.length == 1) {
        this.auth({
          username: this.model.username,
          password: this.model.password,
          company_id: response[0].id,
        });
      } else {
        this.companies = response;
        this.$nextTick(() => {
          this.selectCompanyDialog = true;
        });
      }
      this.hideLoadingIndicator();
    },

    companiesHandlerError(e) {
      var error = {};
      if (e && e.response && e.response.data)
        error = {
          type: "error",
          message: e.response.data.message,
        };
      else error = this.$strings.invalidUserOrPassword;

      this.$store.commit("SET_ALERT_TEXT", error);
      this.alertText = this.handleAlertText();
      this.$forceUpdate();
      this.hideLoadingIndicator();
      return;
    },

    selectCompanyToLogin(company) {
      this.auth({
        username: this.model.username,
        password: this.model.password,
        company_id: company.id,
      });
    },
    fakePopulateCompanies(companies) {
      let company = companies[0];
      for (let i = 0; i <= 4; i++) {
        companies.push(company);
      }
      return companies;
    },
    async authHandler(response) {
      localStorage.setItem("auth_token", response.access_token);
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("auth_token");
      try {
        this.me = await this.$store.dispatch("GET_ME");
        this.novidades = await this.GET_NOVIDADES();
        this.novidade = this.getLastNovidade()
        this.handleNovidade();
      } catch (e) {
        this.selectCompanyErrorHandler(e)
      }
      if (!this.me) {
        console.warn("erro");
        return;
      }
      localStorage.setItem("me", JSON.stringify(this.me));
      if (!this.me.tos_accepted) {
        this.$router.push({ name: "Termos de Serviço" });
      } else {
        this.$router.push({ name: "Início" });
      }
      this.hideLoadingIndicator();
    },

    getLastNovidade() {
      let current_cookies = this.getNovidadesCookie();
      return this.novidades.find(novidade => !current_cookies.includes(novidade.id))
    },

    getNovidadesCookie(){
      return this.$cookie.get("Novidades") ? JSON.parse(this.$cookie.get("Novidades")) : [];      
    },

    errorHandler(error) {
      this.hideLoadingIndicator();
      console.warn(error);
      let errorMessage = this.$strings.invalidUserOrPassword;
      if (error.status == 401) {
        errorMessage.message =
          "Usuário bloqueado, entre em contato com o administrador";
      }
      this.alertText = this.handleAlertText2(errorMessage);
      this.$forceUpdate();
      return;
    },
    selectCompanyErrorHandler(error) {
      this.hideLoadingIndicator();

      let message =
        "Não é possível autenticar com a corretora selecionada no momento. Entre em contato com o SAC para maiores informações.";
      let options = {};
      if (error.data) {
        options = error.data;
      } else if (error.response) {
        options = error.response.data;
      }
      if (options !== undefined && options !== {} && options !== null) {
        message = options.message;
      }

      this.alertText = this.handleAlertText2(message, "error");
      this.selectCompanyDialog = false;
      this.$forceUpdate();
      return false;
    },
    isCreatePasswordPage() {
      return this.$route.name == "Criar Senha" && this.$route.params.hash;
    },
    checkCreatePasswordHash(hash) {
      this.showLoadingIndicator();
      this.$store
        .dispatch("VALIDATE_CREATE_PASSWORD_HASH", { hash })
        .then((response) => {
          this.hideLoadingIndicator();
          this.createPasswordHash = hash;
          this.createPasswordDialog = true;
        })
        .catch(this.errorHandler);
    },
    isBlockUsersPage() {
      return this.$route.name == "Bloquear Usuários" && this.$route.params.hash;
    },
    checkBlockUsersHash(hash) {
      this.showLoadingIndicator();
      this.$store
        .dispatch("LIST_USERS_COMPANY", { hash })
        .then((response) => {
          this.hideLoadingIndicator();
          this.companyUsers = response;
          this.blockUserHash = hash;
          this.blockUserDialog = true;
        })
        .catch(this.errorHandler);
    },

    async handleNovidade() {
      
      let options = {
        title: this.novidade.titulo,
        message: this.novidade.mensagem,
      }
      let cookie = {
        dontAskMeAgainCookie: {
          message: "Não mostrar esta mensagem novamente.",
          action: this.dontAskMeAgainAction,
        },
      }
      let mensagem = Object.assign(options, cookie)
      this.setErrorModal(mensagem);
    },

    dontAskMeAgainAction() {
      let current_cookies = this.getNovidadesCookie();
      current_cookies.push(this.novidade.id);
      this.$cookie.set("Novidades", JSON.stringify(current_cookies));
    },
  },
  mounted() {
    if (this.$route.query.expiredSession) {
      // Ex: http://localhost:8080/#/login?expiredSession=true
      this.alertText = this.handleAlertText2(
        "Sessão expirada, entre com suas credenciais para acessar novamente.",
        "error"
      );
    } else {
      this.alertText = this.handleAlertText();
    }

    if (this.isCreatePasswordPage()) {
      this.checkCreatePasswordHash(this.$route.params.hash);
    }
    if (this.isBlockUsersPage()) {
      this.checkBlockUsersHash(this.$route.params.hash);
    }
    if (
      this.$route.params.debugFlag &&
      this.$route.params.debugFlag == "debug"
    ) {
      this.debugMode = true;
    }
  },
  beforeMount() {
    document.getElementById("iframe-sz-chat").style.display = "none";
    document.getElementById("footer-chat").style.display = "none";
    document.body.style.marginBottom= "0px";
  },
  destroyed() {
    document.getElementById("iframe-sz-chat").style.display = "flex";
    document.getElementById("footer-chat").style.display = "block";
    document.body.style.marginBottom= "50px";  
}
};
</script>

<style lang="scss" scoped>
#jns {
  .login {
    &-error {
      color: red;
      font-weight: bold;
      margin-top: 1rem;
      i {
        color: red;
      }
    }
    &-logo {
      position: absolute;
      top: 54px;
      left: 64px;
    }
  }

  .jns-button-login {
    font-weight: bold;
    border-radius: 45px;
    width: calc(100% + 26px);
    margin-left: -13px;
  }
  .register-button {
    border-radius: 45px;
    width: calc(100% + 26px);
    margin-left: -13px;
  }
  .recover-password-link {
    margin-top: 20px;
  }
  hr {
    margin-top: 20px;
    border: none;

    border-top: 1px solid rgba(25, 23, 55, 0.1);
  }
  .line {
    &-1 {
      font-size: 25px;
      font-weight: 500;
      letter-spacing: 1px;
      line-height: 48px;
      text-align: center;
      text-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.37);
    }
    &-2 {
      font-size: 36px;
      font-weight: 900;
      letter-spacing: 1px;
      margin-bottom: 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/router/views/Login.vue